/**
 * Hero Landing B block script.
 *
 * Plays the page-load entrance choreography across each [data-hero-step] in
 * the hero. Steps vary by style variant (standard / programs / family-rooms /
 * stories / event) but markup order matches visual top-to-bottom in each case.
 *
 * Also initializes the shared video modal for hero variants that opt into
 * a video media type (volunteer, etc.).
 */

import { entranceSequence } from '@/motion-primitives';
import { initVideoModal } from '@/video-modal';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-hero-landing-b').forEach((hero) => {
		const steps = hero.querySelectorAll('[data-hero-step]');
		entranceSequence(Array.from(steps));
	});

	initVideoModal();
});
